export const REFERRALS_SLICE_NAME = "referrals"
